export const USER_TYPES = {
    SUPER_ADMIN: 1,
    SUPERVISOR: 2,
    AGENT: 3,
    CUSTOMER: 4,
    MEMBER: 5,
}

// Status options for general / sales enquiries. API values are new | contacted
// | closed; the labels below are what we surface to the user.
export const INQUIRY_STATUS_OPTIONS = [
    { value: 'new', label: 'Pending' },
    { value: 'contacted', label: 'In Progress' },
    { value: 'closed', label: 'Addressed' },
];

export const TICKET_TYPE_OPTIONS = [
    { value: 'sales', label: 'Sales', },
    { value: 'query', label: 'Query', },
    { value: 'ticket', label: 'Ticket', },
]

export const USER_STATUSES = {
    ACTIVE: "ACTIVE",
    IN_ACTIVE: "IN_ACTIVE",
    SUSPENDED: "SUSPENDED",
}

export const GENDERS = {
    MALE: "MALE",
    FEMALE: "FEMALE",
    OTHERS: "OTHERS",
}

export const TICKET_PRIORITY_OPTIONS = [
    { value: 'low', label: 'Low', },
    { value: 'medium', label: 'Medium', },
    { value: 'high', label: 'High', },
    { value: 'urgent', label: 'Critical', },
    { value: 'scheduled', label: 'Scheduled', },
];

export const getTicketPriorityLabel = (priority?: string | null) => {
    if (!priority) return '-';

    const option = TICKET_PRIORITY_OPTIONS.find(({ value }) => value === priority);
    if (option) return option.label;

    return priority
        .replace(/[_-]+/g, ' ')
        .replace(/\b\w/g, (character) => character.toUpperCase());
};

export const TICKET_SLA_PRIORITY_TONES = {
    P1: { color: '#B3261E', background: '#FDECEC' },
    P2: { color: '#C05600', background: '#FFF1E0' },
    P3: { color: '#1D4ED8', background: '#E8F0FF' },
    P4: { color: '#1B8F3A', background: '#E7F6EA' },
    P5: { color: '#6D28D9', background: '#F1ECFE' },
} as const;

export const TICKET_SLA_STATUS_META = {
    on_track: { label: 'On Track', chipClass: 'lightGreen' },
    at_risk: { label: 'At Risk', chipClass: 'lightOrange' },
    breached: { label: 'Breached', chipClass: 'lightRed' },
} as const;

export const TICKET_SLA_STATUS_OPTIONS = Object.entries(TICKET_SLA_STATUS_META).map(
    ([value, { label }]) => ({ value, label }),
);

export const TICKET_SLA_PRIORITY_OPTIONS = [
    { value: 'P1', label: 'Critical' },
    { value: 'P2', label: 'High' },
    { value: 'P3', label: 'Medium' },
    { value: 'P4', label: 'Low' },
    { value: 'P5', label: 'Scheduled' },
];

export const getTicketSlaStatusMeta = (status?: string | null) => {
    if (!status) return null;
    const normalized = status.toLowerCase().replace(/[\s-]+/g, '_');
    return normalized in TICKET_SLA_STATUS_META
        ? TICKET_SLA_STATUS_META[normalized as keyof typeof TICKET_SLA_STATUS_META]
        : null;
};

export const requiresSlaPriorityChangeReason = (status?: string | null) => {
    const normalized = status?.toLowerCase().replace(/[\s-]+/g, '_');
    return normalized === 'at_risk' || normalized === 'breached';
};

export const ALL_TICKET_STATUS = [
    { value: 'open', label: "Open", },
    { value: 'in_progress', label: "In Progress", },
    // { value: 'escalated', label: "Escalated", disabled: true },
    // { value: 're_open', label: "Re Opened", disabled: true },
    { value: 'on_hold', label: "On Hold", },
    { value: 'resolved', label: "Resolved", },
    { value: 'closed', label: "Closed", },
];

export const ALL_TICKET_INTERNAL_STATUS = [
    { value: 're_assigned', label: "Re Assign", },
    { value: 'solved', label: "Solved", },
    // { value: 'in_progress', label: "In Progress", },
    // { value: 'closed', label: "Closed", },
    // { value: 'escalated', label: "Escalated", },
];
